import React from "react";
import { Link } from "react-router-dom";
import { useI18n } from "../i18n";

const NotFound = () => {
  const { t, lang } = useI18n();
  return (
    <section data-testid="notfound-page" className="bg-[#0B1120] flex-1 flex items-center justify-center py-24 px-5">
      <div className="max-w-xl text-center">
        <span className="text-xs font-mono uppercase tracking-widest text-emerald-400">404</span>
        <h1 className="mt-3 text-4xl sm:text-5xl font-extrabold tracking-tight text-white">
          {t("notFound.title")}
        </h1>
        <p className="mt-4 text-slate-300 leading-relaxed">{t("notFound.text")}</p>
        <Link
          to={`/${lang}`}
          data-testid="notfound-back-home"
          className="mt-8 inline-flex items-center gap-2 px-6 py-3 rounded-md bg-emerald-600 hover:bg-emerald-700 text-white text-sm font-semibold"
        >
          {t("notFound.cta")}
        </Link>
      </div>
    </section>
  );
};

export default NotFound;
